import React, { useContext, useEffect, useState } from "react";
import map from "../../assets/images/omnamo/omnamo/map.png";
import faq2 from "../../assets/images/omnamo/faq2.png";
import EstoreBannerImg from "../../assets/images/new/E-Storebanner.png";
import Breadcrumbs from "../Breadcrumb";
import { useLocation, useNavigate } from "react-router-dom";
import "./TemplePage.css";
import ComingSoonModal from "../ComingSoonModal";
import {
  GetTempleCityList,
  GetTempleList,
} from "../../ApiServices/Temple/TempleApi";
import { LoaderContext } from "../../AuthContext/AuthContext";
import DarshanBookingBannerImg from "../../assets/images/new/DarshanBookingBannerImg.png";
import Batuk from "../../assets/images/new/fav-removebg-preview.png";
import TemplePageImage from "../../assets/images/new/TemplePageImage.png";
import { useTranslation } from "react-i18next";
import { FaMapMarkerAlt } from "react-icons/fa";
import { GiLotus } from "react-icons/gi";
import FilterModal from "../../Pages/RemedyPuja/FilterModal";
import { Helmet } from "react-helmet-async";

const TempleList = () => {
  const userKeyID = localStorage.getItem("userKeyID");
  const [totalRecords, setTotalRecords] = useState(-1)
  const { setLoader, loader, selectedLanguageID, isLanguageUpdate } = useContext(LoaderContext);
  const [showComingSoon, setShowComingSoon] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [TempleCityLst, setTempleCityLst] = useState([]);
  const [TempleLst, setTempleLst] = useState([]);
  const [districtID, setDistrictID] = useState(null);
  const { t } = useTranslation();
  const [metaDesc, setMetaDesc] = useState("Book temple darshan tickets, special pujas & religious ceremonies conveniently through Myomnamo. Plan spiritual pilgrimages with ease and devotion");
  const [metaTitle, setMetaTitle] = useState("Book Quick Temple Darshan & Services Online | Myomnamo");


  const [showFilterModal, setShowFilterModal] = useState(false);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [modelRequestData, setModelRequestData] = useState({
    Action: null,
    pujaServiceID: null,
    pujaSubServiceID: null,
    selectedLocations: [],
    selectedDeity: [],
    selectedBenefits: [],
    selectedCount: 0,
    category: 'Location'
  });
  localStorage.setItem("previousPath", location.pathname);

  useEffect(() => {
    GetTempleListData();
  }, []);

  useEffect(() => {
    if (isFilterApplied || isLanguageUpdate) {
      GetTempleListData();
      setIsFilterApplied(false)
    }
  }, [isFilterApplied, isLanguageUpdate]);

  const GetTempleCityListData = async () => {
    setLoader(true);
    try {
      const response = await GetTempleCityList();

      // ✅ New response structure check
      if (response?.statusCode === 200) {
        const responseData = response?.responseData?.data || [];
        setTempleCityLst(responseData);
      } else {
        console.error("Unexpected response:", response);
      }
    } catch (error) {
      console.error("Error fetching temple city list:", error);
    } finally {
      setLoader(false);
    }
  };
  const GetTempleListData = async (districtId) => {
    setLoader(true)

    try {
      const response = await GetTempleList({
        pageNo: 0,
        pageSize: 100,
        appLangID: Number(selectedLanguageID),
        deityIDs: modelRequestData?.selectedDeity || [],
        benefitsIDs: modelRequestData?.selectedBenefits || [],
        districtIDs: modelRequestData?.selectedLocations || [],
      });

      if (response) {
        if (response?.statusCode === 200) {
          setLoader(false);

          const leadList = response.responseData.data;
          const totalCount = response.totalCount;

          // setTotalPages(Math.ceil(totalCount / pageSize));

          setTotalRecords(leadList?.length);
          setTempleLst(leadList);

        } else {
          console.error(response?.data?.errorMessage);
          setLoader(false);
        }
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  const handleCityClick = (districtId) => {
    setDistrictID(districtId);
  };

  const handleAllTemplesClick = () => {
    setDistrictID(null); // Set to null to fetch all temples
  };

  const handleFilterClicked = (module) => {

    setModelRequestData((prev) => ({ ...prev, category: module }))
    setShowFilterModal(true);
  };

  return (
    <>
      <Helmet>
        <title>
          {metaTitle}
        </title>
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="website" />
        <meta
          name="description"
          content={metaDesc}
        />
        <link rel="canonical" href="https://www.myomnamo.com/temples" />
        <meta
          property="og:title"
          content={metaTitle}
        />
        <meta
          property="og:description"
          content={metaDesc}
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content={metaTitle}
        />
        <meta
          name="twitter:description"
          content={metaDesc}
        />

      </Helmet>
      <section className="page-header" style={{ paddingBottom: '28px' }}>
        <div
          className="page-header__bg horoscope-banner-responsive"
          style={{ backgroundImage: `url(${DarshanBookingBannerImg})` }}
        ></div>
        <div className="container" style={{ display: 'block' }}>
          <h2 className="page-header__title bw-split-in-left">  {t("Temples")}</h2>
          <div className="d-flex justify-content-center">
            <Breadcrumbs />
          </div>
        </div>
      </section>

      <section
        className="about-one about-one--about"
        style={{ padding: "0px 0 0px" }}
      >
        <div className="container">
          <div className="row g-0 align-items-start mt-3">
            <div className="col-xl-6 pe-0 ">
              <div
                className="about-one__image wow fadeInLeft temple-ImagesGrid mx-2"
                data-wow-delay="100ms"
                style={{ paddingBottom: '40px' }}
              >
                <div className="about-one__image__one w-100 w-md-95"  >
                  <img src={TemplePageImage} alt="careox" />
                </div>
              </div>
            </div>
            <div
              className="col-xl-6 ps-0 wow fadeInRight"
              data-wow-delay="200ms"
            >
              <div className="about-one__content">
                <div className="sec-title text-left">
                  <h1 className={`${selectedLanguageID == 3 ? "sec-marathi-title__title" : "sec-title__title"} bw-split-in-left`}>
                    {t("Discover India’s Sacred Temples and Holy Pilgrimage Sites")}
                  </h1>
                </div>
                <ul className="about-one__content__list">
                  <li>
                    <span className="about-one__content__list__icon">
                      <i className="icofont-check-circled"></i>
                    </span>
                    {t("Explore sacred sites rich in culture and ancient traditions.")}
                  </li>
                  <li>
                    <span className="about-one__content__list__icon">
                      <i className="icofont-check-circled"></i>
                    </span>
                    {t("Find temples of beloved deities for spiritual connection.")}
                  </li>
                  <li>
                    <span className="about-one__content__list__icon">
                      <i className="icofont-check-circled"></i>
                    </span>
                    {t("Plan pilgrimages with travel guides and festival details.")}
                  </li>
                </ul>


              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Filters */}
      <div className="d-flex gap-3 mb-5 justify-content-center flex-wrap">
        {/* Filter button */}
        <button
          type="button"
          className="d-flex align-items-center gap-2 px-4 py-2 mainFilter"

          onClick={() => handleFilterClicked("Location")}
        >
          <i className="bi bi-sliders" style={{ fontSize: "18px" }}></i>
          {t("Filter")}
          {modelRequestData?.selectedCount > 0 && (
            <span
              className="badge ms-1 badgeCount"

            >
              {modelRequestData?.selectedCount}
            </span>
          )}
        </button>

        {/* Location */}
        <button
          type="button"
          className="d-flex align-items-center gap-2 px-4 py-2 locationFilter"

          onClick={() => handleFilterClicked("Location")}
        >
          {t("Location")}
          {modelRequestData?.selectedLocations?.length > 0 && (
            <span
              className="badge ms-1 badgeCount"

            >
              {modelRequestData?.selectedLocations?.length}
            </span>
          )}
          <i className="bi bi-chevron-down" style={{ fontSize: "14px" }}></i>
        </button>

        {/* Benefits */}
        <button
          type="button"
          className="d-flex align-items-center gap-2 px-4 py-2 benefitFilter"

          onClick={() => handleFilterClicked("Benefits")}
        >
          {t("Benefits")}
          {modelRequestData?.selectedBenefits?.length > 0 && (
            <span
              className="badge ms-1 badgeCount"

            >
              {modelRequestData?.selectedBenefits?.length}
            </span>
          )}
          <i className="bi bi-chevron-down" style={{ fontSize: "14px" }}></i>
        </button>

        {/* Deity */}
        <button
          type="button"
          className="d-flex align-items-center gap-2 px-4 py-2 deityFilter"
          onClick={() => handleFilterClicked("Deity")}
        >
          {t("Deity")}
          {modelRequestData?.selectedDeity?.length > 0 && (
            <span
              className="badge ms-1 badgeCount"

            >
              {modelRequestData?.selectedDeity?.length}
            </span>
          )}
          <i className="bi bi-chevron-down" style={{ fontSize: "14px" }}></i>
        </button>
      </div>

      {/* 
      <div className="category-tabs-container " id="All">
        <ul className="nav justify-content-center border-bottom">
          <button
            className={`button ${districtID === null ? "is-checked" : ""}`}
            onClick={handleAllTemplesClick}
            style={{ fontSize: "medium" }}
          >
            <div className="btn-column" >

              <span>All</span>
            </div>
          </button>
          {TempleCityLst.map((filter, index) => (
            <button
              key={index}
              className={`button ${districtID === filter.districtID ? "is-checked" : ""
                }`} // Update this line
              onClick={() => handleCityClick(filter.districtID)}
              style={{ fontSize: "medium" }}
            >
              <div className="btn-column" >

                <span>{filter.districtName}</span>
              </div>
            </button>
          ))}
        </ul>
        <br></br>

      </div> */}

      <div data-js="hero-demo " className="templeList">

        <ul className="grid ">
          {TempleLst?.length > 0 ? (
            TempleLst.map((val, index) => (
              <li
                key={index}
                className={`element-item cat-${val.category}`}
                data-category={`cat-${val.category}`}
                onClick={() =>
                  navigate(`/${val.templeSlug}`, { state: { slug: val.templeSlug } })
                }
                style={{ cursor: "pointer", height: '22em' }}
              >
                <div
                  style={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <img
                    src={val.templeImage || faq2}
                    alt="gallery-img"
                    style={{ height: '45%', objectFit: 'fill', width: '100%' }}
                  />

                  <div
                    className="content-section"
                    style={{
                      flex: '1 1 auto',
                      overflowY: 'auto',
                      padding: '0.5em',
                      scrollbarWidth: "thin"
                    }}
                  >
                    <h5 className="text-title">{val.templeName}</h5>

                    {val.templeAddress && (
                      <p style={{ fontSize: '12px' }}>
                        <FaMapMarkerAlt size={14} style={{ color: "#991b3d", marginRight: "6px" }} />
                        {val.templeAddress}
                      </p>
                    )}

                    {val.deities && (
                      <p style={{ fontSize: '12px' }}>
                        <GiLotus size={14} style={{ color: "#991b3d", marginRight: "6px" }} />
                        {val.deities}
                      </p>
                    )}

                    <div style={{ marginTop: "10px", display: "flex", flexWrap: "wrap", gap: "6px" }}>
                      {val.benefits?.split(",").map((benefit, i) => (
                        <span
                          key={i}
                          style={{
                            background: "#f4b72233",
                            color: "#991b3d",
                            fontSize: "10px",
                            padding: "4px 10px",
                            borderRadius: "12px",
                          }}
                        >
                          {benefit.trim()}
                        </span>
                      ))}
                    </div>
                  </div>

                  {/* Fixed at bottom */}
                  <div
                    className="service-two__item__rm"
                    style={{
                      marginTop: 'auto',
                      padding: '0.5em',
                      borderTop: '1px solid #eee',
                      background: '#fff',
                    }}
                  >
                    <span style={{ color: '#a52444' }}>{t("Visit Now")}</span>
                    <i className="icon-right-arrow"></i>
                  </div>
                </div>
              </li>

            ))
          ) : loader === false ? (
            <div className="d-flex flex-column align-items-center justify-content-center vh-90 text-center mt-4" style={{ width: '100%' }}>
              <img
                src={Batuk}
                alt="Empty Cart"
                className="img-fluid mb-3"
                style={{ maxWidth: "200px" }}
              />
              <h5 className="fw-bold" style={{ textAlign: "center" }}>
                No Temples available for this category
              </h5>
              <p className="text-muted">
                Please explore our other Cities.
              </p>
            </div>
          ) : null}


        </ul>
      </div>

      <ComingSoonModal
        show={showComingSoon}
        onClose={() => setShowComingSoon(false)}
      />
      <FilterModal
        show={showFilterModal}
        onHide={() => setShowFilterModal(false)}
        modelRequestData={modelRequestData}
        setModelRequestData={setModelRequestData}
        setIsFilterApplied={setIsFilterApplied}
      />
    </>
  );
};

export default TempleList;
